import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isAuth: !!sessionStorage.getItem('logged'),
    // eslint-disable-next-line no-extra-boolean-cast
    logged: !!sessionStorage.getItem('logged') ? JSON.parse(sessionStorage.getItem('logged')) : null,
    duplicates: [],
    progressColor: 'white'
  },
  mutations: {
    // Mutating the state. Must be synchronous
    logoff (state) {
      sessionStorage.removeItem('logged')
      state.isAuth = !!sessionStorage.getItem('logged')
    },
    authenticate (state, payload) {
      sessionStorage.setItem('logged', JSON.stringify(payload))
      state.isAuth = !!sessionStorage.getItem('logged')
      state.logged = JSON.parse(sessionStorage.getItem('logged'))
    },
    duplicates (state, payload) {
      state.duplicates = payload
    },
    progressColor (state, payload) {
      state.progressColor = payload
    }

  },
  getters: {
    isLoggedIn (state) {
      return state.isAuth
    },
    isLoggedNRS (state) {
      return state.isAuth && state.logged.nrs
    },
    Logged (state) {
      return state.logged
    },
    Duplicates (state) {
      return state.duplicates
    },
    progressColor (state) {
      return state.progressColor
    }
  },
  actions: {
  // Committing the mutations. Can be asynchronous
    logoff: ({ commit }) => commit('logoff'),
    authenticate: async ({ commit }, payload) => {
      commit('authenticate', payload)
    },
    duplicates: async ({ commit }, payload) => {
      commit('duplicates', payload)
    },
    progressColor: async ({ commit }, payload) => {
      commit('progressColor', payload)
    }
  }
})
